import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useSidebar } from "@/components/ui/sidebar.utils";
import { Link, useLocation } from "react-router";
import { SidebarItem } from "../utils/sidebarLinks";
import { isRouteActive } from "../utils/isRouteActive";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

function Item({ item }: { item: SidebarItem }) {
  const { open, isMobile, setOpenMobile } = useSidebar();
  const location = useLocation();
  const isActive = isRouteActive(location.pathname, item.url);

  const iconClassName = `w-6 h-6 ${isActive ? "text-brand-primary" : ""}`;

  const handleClick = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return open ? (
    <SidebarMenuItem>
      <SidebarMenuButton asChild>
        <Link to={item.url} onClick={handleClick}>
          {item.icon && <item.icon className={iconClassName} />}
          <span className={isActive ? "text-brand-primary" : ""}>
            {item.title}
          </span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  ) : (
    <SidebarMenuItem>
      <HoverCard openDelay={150} closeDelay={150}>
        <HoverCardTrigger asChild>
          <SidebarMenuButton asChild>
            <Link to={item.url} onClick={handleClick}>
              {item.icon && <item.icon className={iconClassName} />}
              <span className={isActive ? "text-brand-primary" : ""}>
                {item.title}
              </span>
            </Link>
          </SidebarMenuButton>
        </HoverCardTrigger>
        <HoverCardContent
          side="right"
          align="center"
          className="px-4 py-2 w-fit"
        >
          <Link to={item.url} onClick={handleClick}>
            {item.title}
          </Link>
        </HoverCardContent>
      </HoverCard>
    </SidebarMenuItem>
  );
}

export default Item;
